// extracted by mini-css-extract-plugin
export var standaloneTable = "_gf-0";
export var withExtraHeader = "_gf-1";